import type { FaireProductEntity } from "../../entity_types/product";

export const p_7juwv3584c: FaireProductEntity = {
  token: "p_7juwv3584c",
  type: "product",
  name: "Praise Him soft crinkle baby book",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/8110831199248fd584dcfdc503edcdddd4c440dd5a44e0d213447d3136df7343.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0656e02f0d8c27a9a675037c8ee29b282953d24cac388c92acc8927af043501f.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
